import { useRemoteConfigStore } from "@/store/remoteConfig";

export default defineNuxtPlugin(() => {
    const route = useRoute();
    const { $i18n } = useNuxtApp();
    const remoteConfig = useRemoteConfigStore();
    const lang = route.query.lang as string | undefined;

    if (lang && (lang === "sv" || lang === "en")) {
        $i18n.setLocale(lang);
        remoteConfig.defaultLocale = lang;
    } else {
        const browserLocale = $i18n.locale.value;
        if (browserLocale && !remoteConfig.defaultLocale) {
            remoteConfig.defaultLocale = browserLocale;
        }
    }
});
